// Product ID to single Variant ID mapping
let tangent_selected_product_map;
let totalCartValue = 0;
let default_addToCartText = "Add To Cart";
const default_addedToCartText = "Added to Cart!";
const default_add_all_to_cart_text = "Add All to Cart"
const out_of_stock_text = "Out of Stock";
const no_products_found_text ="No products found. Please retry!";
const all_p_car_ids = [];
let tangent_hairmap_data;
let tangent_client_url;
let tangent_recommended_products;

let tangent_client_domain_currency;
// Map variable to store add all to cart links for each sections
let sections_add_to_cart_map={};

// Tab title mapping based on tags
const tabs_title_mapping={
  routine_1:"Your rhoco Ritual",
  routine_2:"Just Get Me Started"
}

// Add default image url here
const tangent_default_selfie_image_url="";
const default_variant_image_url ="https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp"

const tangent_custom_tabs = document.querySelector("#tangent_custom_tabs");
const tangent_client_domain_url = window.location.origin;
const tangent_sections_wrapper_element = document.querySelector("#tangent_sections_wrapper"); 
const tangent_section_routine_1 = document.querySelector("#section_routine_1_container"); 
const tangent_section_routine_2 = document.querySelector("#section_routine_2_container"); 
const tangent_skin_type_tagging = document.querySelector("#skin-type-taging");


function onLoadFunction(){
  var tangent_response_id = getClientResponseId()
  checkoutDataApiCall(tangent_response_id);
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", (event) => {
        onLoadFunction();
    });
} else {
    onLoadFunction();
}


function getClientResponseId(){
  // Current Page Load URL
  tangent_client_url = new URL(window.location.href);
  return tangent_client_url.searchParams.get("resp_id");
}

function checkoutDataApiCall(tangent_response_id){
  if (tangent_response_id != null) {
    const checkout_url = "https://service.tangent.ai/shopify/get-checkout-products?resp_id="+tangent_response_id+ "&self_serve=true" + "&multiple_variants=true";
    fetch(checkout_url)
    .then(data => {
      return data.json();
    })
    .then(response => {
      checkoutDataProcess(response);
      return response;
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
}

function checkoutDataProcess(response){
    tangent_recommended_products = response.products;

    setUserNameOnTitle(response);
    tangent_client_domain_currency = document.querySelector("#tangent_client_currency").innerText; 

    // Setting Default variant price symbol
    if (tangent_client_domain_currency == "") {
        tangent_client_domain_currency = '$';
    }

    // Setting selfie / default image
    setTangentSelfieSection(response);
  
    // Used for spider chart creation
    if(response["selfie_id"]!=null){
      getSelfieMapping(response["selfie_id"]);
      setElementDisplay("section_chart_container","flex");
      enableSelfieDependedStaticElements();
    }
  
    const tangent_product_sections = response.product_sections;
    const tangent_text_sections = response.text_sections;
    
    if(tangent_product_sections!=undefined){
      createProductSection(tangent_product_sections, tangent_text_sections);
    }    

    for(var tab_title in tabs_title_mapping){
      createTabButton(tab_title);
    }

    setTabOpen(response.tags);
    if(response.text_sections!=undefined){
      createTextSection(tangent_product_sections,tangent_text_sections);
    }

    if (tangent_recommended_products.length > 0) {
        setProductsToView(tangent_recommended_products, tangent_product_sections, response.selected_variants);
        createCartDiscount();
        enableButtonListener();
        loadElementsOnResponseData(); 
        setSelfieHairType(response.tags);   
    }
}

function setUserNameOnTitle(response) {
  const userName = response?.form?.first_name?.trim();
  const tangentTitleInput = document.querySelector("#tangent-selfie-title");

  if (userName && tangentTitleInput) {
    tangentTitleInput.innerHTML = `${userName}'s Analysis<br>Hair Summary`;
  }
}


function runOnceWhenElementAppears(selector, callback, interval = 100, timeout = 5000) {
  const startTime = Date.now();

  const check = setInterval(() => {
    const el = document.querySelector(selector);

    if (el) {
      clearInterval(check);
      callback(el); // Run your function ONCE
    }

    if (Date.now() - startTime > timeout) {
      clearInterval(check);
      console.warn('Element not found within timeout:', selector);
    }
  }, interval);
}

const setElementDisplayById = (elementId, displayStyle) => {
  const element = document.getElementById(elementId);
  if (element) {
      element.style.display = displayStyle;
  }
}
function getSelfieMapping(selfie_id){
   var selfie_api_url = "https://service.tangent.ai/shopify/upload-selfie?selfie_id="+selfie_id+"&user=mango"
   var xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        var DONE =  (typeof XMLHttpRequest.DONE !== 'undefined') ? XMLHttpRequest.DONE : 4;
        if (xmlhttp.readyState == DONE) { 
            if (xmlhttp.status == 200) {
              var response_json = JSON.parse(xmlhttp.responseText);

              tangent_hairmap_data = response_json["selfie_record"][0].hairdamage;
              if(tangent_hairmap_data){
                setScores(tangent_hairmap_data, selfie_id);
              }
              else{
                setElementDisplay("text-parent-container","none");
                setElementDisplay("section_chart_container","none");
              }
            }
            else if (xmlhttp.status == 400) {
                console.log('There was an error 400');
            }
            else {
                console.log('Something else other than 200 was returned');
            }
        }
    };

    xmlhttp.open("GET", selfie_api_url, true);
    xmlhttp.send();
}

function drawChartCustom(params_list) {
  var attr_list = [];
  for (const param of params_list){
      attr_list.push({
          "x": param.key.toUpperCase(),
          "value": param.value
      });
  }
  // create a chart
  drawRadarChart(attr_list);
}

function drawChart(params) {
  const attributeNames = ["Dryness", "Frizz", "Split Ends", "Flyaways"];
  var selfie_conditions = params.selfie_record[0].hairdamage.attributes;
  var attr_list = [];
  for (const attributeName of attributeNames){
      attr_list.push({
          "x": attributeName.toUpperCase(),
          "value": getAttributeScore(selfie_conditions, attributeName)
      });
  }
  // create a chart
  drawRadarChart(attr_list);
}

function getAttributeScore(attributeMap, attributeName, minimum=0.2){
   if(attributeMap.hasOwnProperty(attributeName)){
      return attributeMap[attributeName].score; 
    }
    return 1;
}

function drawRadarChart(list){
  setElementDisplay("chart-loading-section","none");
  var chart = anychart.radar();
  var interactivity = chart.interactivity();
  interactivity.hoverMode("bySpot");
  interactivity.spotRadius(0);

  chart.tooltip(false);
  chart.yScale().ticks().interval(1);
  chart.yScale().minimum(0);
  chart.yScale().maximum(10);
  chart.area(list).fill("rgba(248, 240, 231, 0.6)").stroke("rgba(248, 240, 231, 1)");


  var labels = chart.yAxis().labels();
  labels.enabled(false);
  chart.labels().fontFamily("Futura");
  chart.container("graph_container");
  chart.draw();
}

function setScores(hair_damage_response, selfie_id) {
  let damage_attributes = hair_damage_response.attributes;
  let damage_level = hair_damage_response.damage;
  const concernMap = {
    Flyaways: "Flyaways",
    Shine: "Shine",
    Dryness: "Dryness",
    SplitEnds: "SplitEnds",
    Frizz: "Frizz"
  };

  let scores_present = false;
  let score_obj=[];
  
  Object.keys(concernMap).forEach(key => {
    let value = 5;
    const containerId = `${concernMap[key]}_Score_container`;
    const scoreId = `#${concernMap[key]}_Score`;
    setElementDisplayById(containerId, "flex");
    const circle = document.getElementById(containerId);
    if (concernMap[key]) {
      // To handle when any attribute is absent in the API response
      if(!damage_attributes[key]){
        damage_attributes[key]={
          loc:[],
          score:0
        };
      }
      if(key=="Shine"){
        value = damage_attributes[key].score;
      }
      else{
        value = value - damage_attributes[key].score;
      }
      value = getFinalScore(key, value, damage_level.score, selfie_id)
    }
    score_obj.push({value:value, key: key});
    setBorderFill(circle, value); 
    document.querySelector(scoreId).innerHTML = value;
    scores_present = true;
  });
  drawChartCustom(score_obj);
  // Show facemap container only if at least one concern is found

  
  setElementDisplayById("hairmap_all_scores_container", scores_present ? "flex" : "none");
}

function getFinalScore(attributeKey, attributeValue, hairdamagLevelScore, selfieID, attributeMinValue=4){
 if (attributeMinValue===0 && attributeKey==="Shine"){
   attributeValue = hairdamagLevelScore;
 }
 var randomSalt =  selfieIDToDeterministicRandomSync(selfieID + attributeKey);
 var finalAttributeValue = attributeMinValue + attributeValue + randomSalt;
 return Math.max(finalAttributeValue,5);
}

function selfieIDToDeterministicRandomSync(selfieID) {
  // FNV-1a 32-bit hash
  let hash = 0x811c9dc5;
  for (let i = 0; i < selfieID.length; i++) {
    hash ^= selfieID.charCodeAt(i);
    hash = (hash * 0x01000193) >>> 0; // >>> 0 ensures unsigned 32-bit integer
  }

  // Normalize to a float in [0, 0.9)
  
  const value = (hash / 0x100000000) * 0.9; // 2^32
  return Math.round(value * 10) / 10;
}

function setBorderFill(el, value, max = 10) {
  const percent = (value / max) * 100;
  el.style.setProperty('--value', percent);
}

function setSelfieHairType(tags) {
  const hairTypeTextElement = document.getElementById("hair-type-text");
  const hairTypes = ["straight", "wavy", "curly", "coily","2a","2b","2c","3a","3b","3c","4a","4b","4c"];
  // Detect all hair types that are substrings in the tags
  const detectedTypes = hairTypes.filter(type =>
    tags.some(tag => tag.toLowerCase().includes(type))
  );

  if (hairTypeTextElement) {
    if (detectedTypes.length > 0) {
      const formattedTypes = detectedTypes.map(type => capitalizeFirstLetter(type));

      const hairTypeText = formattedTypes.length > 1
        ? `Your hair type is ${formattedTypes.join(" - ")}`
        : `Your hair type is ${formattedTypes[0]}`;

      hairTypeTextElement.innerHTML = hairTypeText;
    } else {
      hairTypeTextElement.innerHTML = "No hair type detected.";
    }
  }
}

// Helper to capitalize first letter
function capitalizeFirstLetter(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

function capitalizeFirstLetter(word) {
  return word.charAt(0).toUpperCase() + word.slice(1);
}

function enableSelfieDependedStaticElements(){
  setElementDisplayById("tangent_score_description", "block");
  setElementDisplayById("skin-health-title-container", "block");
}

function setProductsToView(products, sections, selected_variants) {
  tangent_selected_product_map = {};
  Object.keys(sections).forEach(section => {
    const product_ids = sections[section];
    const product_section_grid = document.getElementById(section + "_product_grid");
    const allpatcform = document.getElementById('addallptocart');
    // Create a document fragment for improved performance
    const fragment = document.createDocumentFragment();
    
    for (const id of product_ids) {
      for (let p = 0; p < products.length; p++) {
        // Find product by ID
        if (String(products[p].id) === id) {
          const product = products[p];
          const variant = getSelectedVariant(product, selected_variants[product.id]);
          const variantId = variant.id.split("/").pop();
          // Track selected product variant
          tangent_selected_product_map[product.id] = variantId;
          // Generate product HTML and append it to the fragment
          const product_html = getProductHTML(product, p, variant, section, sections, variantId);
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = product_html;
          if(section == "section_phase_1" || section =="section_phase_2" || section == 'section_phase_3'){
            all_p_car_ids.push(variantId);
          }
          // Append the created product HTML to the fragment
          while (tempDiv.firstChild) {
            fragment.appendChild(tempDiv.firstChild);
          }
        }
      }
    }
    if(section!="section_multiple_routine" && section!="section_single_set_routine"){
      // Append the fragment to the DOM in one go
      product_section_grid.appendChild(fragment);
    }
  });
}

function getSelectedVariant(product, variant_list) {
  const productVariants = product.variants || [];
  if (productVariants.edges.length === 0) {
    throw new Error("No variants available for the product.");
  }
  
  if (variant_list.length > 0) {
    const selectedVariantId = Number(variant_list[0]);
    return productVariants.edges.find(variant => variant.node.id === selectedVariantId) || productVariants.edges[0].node;
  }
  
  return productVariants.edges[0].node;
}

function extractShopifyNumericId(gid) {
  if (typeof gid !== 'string') return null;

  const match = gid.match(/\d+$/);
  return match ? match[0] : null;
}




function getProductHTML(product, index, variant, section, sections, variantId) {
  // Setting default / first variant data
  
  const variant_image_url = getVariantImage(variant, product);
  const variant_product_url = `${tangent_client_url.origin}/products/${product.handle}?variant=${variantId}`;
  
  let buttonClass="";
  let addbuttontext = default_addToCartText;
  if(isProductAvailable(product, variant)){
    updateSectionAllToCartLink(sections, product.id, tangent_selected_product_map[product.id], section);
  }
  else{
    addbuttontext = out_of_stock_text;
    buttonClass ="disable-button";
  }

  //get rating html
  const ratingValue = product?.reviews_rating?.value;
  const ratingCount = product?.reviews_count?.value;
  let ratingHtml = "";
  if(ratingValue){
    ratingHtml = getRatingHtml(index, ratingValue, ratingCount);
  }

  // Product View HTML using template literals
  // const product_html = `
  //   <div>
  //     <div class="product_view">
  //       <a id="url_tangent_product_${index}" class="tangent-text-link dfgdgdgdgdf" target="_blank" href="${variant_product_url}">
  //         <img id="image_tangent_product_${index}" src="${variant_image_url}" class="tangent_product_image" alt="${product.title}">
  //         <p class="tangent-product-title tangent_product_title_text">${product.title}</p>
  //         ${ratingHtml}
  //         ${getPriceHTML(variant.price)}
  //       </a>
  //       <div id="${section}_variant_${index}"></div>
  //       <button class="tangent-product-add-btn-wrapper product-item tangent-btn-add tangent_add_to_cart_button btn ${buttonClass}" id="${variantId}" data-variantId="${variantId}">
  //           ${addbuttontext}
  //       </button>
  //     </div>
  //   </div>
  // `;

  const product_html = `
    <div>
      <div class="product_view">
        <a id="url_tangent_product_${index}" class="tangent-text-link dfgdgdgdgdf" target="_blank" href="${variant_product_url}">
          <img id="image_tangent_product_${index}" src="${variant_image_url}" class="tangent_product_image" alt="${product.title}">
          <p class="tangent-product-title tangent_product_title_text">${product.title}</p>
          ${ratingHtml}
          ${getPriceHTML(variant.price)}
        </a>
        <div id="${section}_variant_${index}"></div>
        <product-form x-data="productAddButtonForm()" class="product__block__buttons" style="--PB: 20px;">
          <div data-product-form-outer="">
            <form method="post" action="/cart/add" id="product-form-template--25404712976649__main-${product.title}" accept-charset="UTF-8" class="shopify-product-form" enctype="multipart/form-data" data-product-form="" data-product-handle="scalp-soothe-essential-brush-set">
              <input type="hidden" name="form_type" value="product">
              <input type="hidden" name="utf8" value="✓">
              <div class="product__form__inner" data-form-inner="">
                <div class="product__submit" data-buttons-wrapper="" data-add-action-wrapper="" data-error-boundary="">
                  <div data-error-display="" role="alert" class="add-action-errors"></div>
                  <div class="product__submit__buttons product__submit__buttons--clear">
                  <span class="sr-only" aria-live="polite" x-show="isLoading" style="display: none;">
                  Adding to Cart
                  </span>
                    <span class="sr-only" aria-live="polite" x-show="isSuccess" style="display: none;">
                    Added to Cart
                    </span>

                    <button type="submit" name="add" class="tangent-product-add-btn-wrapper product-item tangent-btn-add tangent_add_to_cart_button btn " data-add-to-cart="" aria-label="Add to Cart" :class="{
                    'has-success': isSuccess,
                    'loading': isLoading
                    }">
                      <span class="btn-state-ready">
                        <span data-add-to-cart-text="">Add to Cart</span>
                      </span>

                      <span class="btn-state-loading">
                        <svg height="18" width="18" class="svg-loader">
                        <circle r="7" cx="9" cy="9"></circle>
                        <circle stroke-dasharray="87.96459430051421 87.96459430051421" r="7" cx="9" cy="9"></circle>
                        </svg>
                      </span>
                      <span class="btn-state-complete">&nbsp;</span>
                    </button>
                  </div>
                </div>
              </div>
            <div class="shop-pay-terms"></div>
            <input type="hidden" name="id[]" value="${variantId}">
            </form>
          </div>
        </product-form>
      </div>
    </div>
  `;
  
  return product_html;
}

const getPriceHTML = (price) =>{
  const discountedPrice = getDiscountedPrice(price, 10);
  return `
  <p class="price-item--regular tangent-regular-price-on-sale price tangent-product-price-text tangent-original-price price">
    <span class='notranslate' htmoney=""><del>${tangent_client_domain_currency} ${price}</del> <strong>${tangent_client_domain_currency} ${discountedPrice}</strong> with code: TRICHOMATCH10</span>
  </p>`;
}

function getDiscountedPrice(price, discount) {
  const discounted = price - (price * (discount / 100));
  return discounted.toFixed(2); // Always returns a string with 2 decimals
}

function getRatingHtml(p, reviewRating, ratingCount) {
      const ratingContainer = document.createElement("div");
      ratingContainer.classList.add("star-rating");
      const totalStars = 5;
      const rating = JSON.parse(reviewRating).value;
      const fullStars = Math.floor(rating);
      const hasHalfStar = rating % 1 >= 0.1;
      const emptyStars = totalStars - fullStars - (hasHalfStar ? 1 : 0);

      // Full stars
      for (let i = 0; i < fullStars; i++) {
        const star = document.createElement('div');
        star.classList.add('jdgm-star', 'jdgm--on');
        ratingContainer.appendChild(star);
      }

      // Half star
      if (hasHalfStar) {
        const star = document.createElement('div');
        star.classList.add('jdgm-star', 'jdgm--half');
        ratingContainer.appendChild(star);
      }

      // Empty stars
      for (let i = 0; i < emptyStars; i++) {
        const star = document.createElement('div');
        star.classList.add('jdgm-star','jdgm--off');
        ratingContainer.appendChild(star);
      }
      const ratingCountElement = document.createElement("p");
      ratingCountElement.classList.add("rating-count");
      ratingCountElement.innerHTML = `${ratingCount} reviews`;
      ratingContainer.appendChild(ratingCountElement);
      return ratingContainer.outerHTML;
}


function isProductAvailable(product, variant){
  // Check if the product is active
  if (product.status.toLowerCase() !== "active") {
      return false;
  }
  return variant.availableForSale;
}

function setTabOpen(tags){
  // Setting 1st tab active by default
  document.querySelector("#tab-wrapper").style.display="flex";
  // By Default first tab is selected and opened
  document.querySelectorAll(".tabcontent")[0].style.display="block";
  document.querySelectorAll(".tablinks")[0].classList.add("active");
}

// Updating add all to cart object for sections
function updateSectionAllToCartLink(product_sections, product_id, vid) {
    if (!product_sections) return;
    
    for (const section in product_sections) {
        if (product_sections[section].includes(String(product_id))) {
            // Initialize section if it doesn't exist
            if (!sections_add_to_cart_map[section]) {
                sections_add_to_cart_map[section] = {
                    count: 0,
                    cart_link: tangent_client_domain_url + "/cart/add?",
                    list: []
                };
            }

            // Update section if vid is not already included
            const sectionData = sections_add_to_cart_map[section];
            if (!sectionData.list.includes(vid)) {
                sectionData.count++;
                sectionData.cart_link += `&id[]=${vid}`;
                sectionData.list.push(vid);

                // Show "Add All to Cart" button if more than one product
                const addAllButton = document.getElementById(`${section}`);
                if (addAllButton) {
                    addAllButton.style.display = sectionData.count > 1 ? "block" : "none";
                }
            }
        }
    }
}


function createFormDataFromIds(idArray) {
  return {
    items: idArray.map(id => ({
      id: id,
      quantity: 1
    }))
  };
}

function addToCart(element){ 
  const formData = createFormDataFromIds([element.id]);
  addToCartApi(formData, element);
}

// Add all to cart function for sections
function addAllTocartFunction(element) {
  
  const formData = createFormDataFromIds(sections_add_to_cart_map[element.id].list);
  if(formData){
    addToCartApi(formData, element);
  } 
  else {
      var x = document.querySelector("#message-text");
      x.innerHTML = "We're currently sold out of the selected product(s). Please check back later!";
      x.className = "show";
      setTimeout(function () { x.className = x.className.replace("show", ""); }, 5000);
  }
}

function addToCartApi(payload, element){
  element.innerHTML = `<div class="loader button-loader">&nbsp;</div>`
  fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
  }).then(() => {
    element.innerHTML = default_addedToCartText;
    element.classList.add("added-to-cart-style"); 
  }).catch((error) => {
      console.error('Error:', error);
  });
}

const getProductData = (sectionName) => {
  const sectionVariantList= sections_add_to_cart_map[sectionName].list;
  const allVariantList = Object.values(tangent_selected_product_map);
  let productData = {
   'items': []
  };
  for (let variantId of sectionVariantList) {
    let item = {
      'id': variantId,
      'quantity': 1,
      'properties': {
        '_type': 'tangent-quiz'
      }
    }
    productData.items.push(item);
  }
  return productData;
}

const getVariantImage = (variant, product) => {
  const fallbackImage = 'https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp';
  if (variant.image) {
    return variant.image
  }
  if(product?.images?.nodes.length > 0){
    return product?.images?.nodes[0].url
  }
  return fallbackImage;
};

// Add To Cart Function
function addToCartFunction(cartButton){ 
  let variantId = Number(cartButton.getAttribute("data-variantId"));
  if(cartButton){

    // const sections = miniCart ? miniCart.getSectionsToRender().map((section) => section.id) : [];
    
    let formData = {
     'items': [{
      'id': variantId,
      'quantity': 1,
      'properties': {
        '_type': 'tangent-quiz'
      }
      }],
      'sections': sections,
      'sections_url': window.location.pathname
    };
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      cartButton.innerHTML = default_addedToCartText;
      cartButton.classList.add("added-to-cart-style"); 
      showMessage("ADDED TO CART!");
      document.dispatchEvent(new CustomEvent('cart:build' , {bubbles: true})); 
      document.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
      }));
      return response.json();
    }).then((parsedState) => {
      // Open cart drawer
      miniCart && miniCart.renderContents(parsedState);
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: {
          product: parsedState
        }
      }));
    }).catch((error) => {
      console.error('Error:', error);
    });
  }
}

// Main Section container 
function createSectionContainer(section_name){
    var section_container = document.createElement("div");
    section_container.id=section_name+"_container";
    return section_container;
}

function getTotalVariantPrice(products, variantIds) {
  let total = 0;

  products.forEach(product => {
    product?.variants?.edges?.forEach(edge => {
      const variant = edge.node;
      const variantNumericId = Number(variant.legacyResourceId);
      if (variantIds.includes(variantNumericId.toString())) {
        total += parseFloat(variant.price || 0);
      }
    });
  });

  return total.toFixed(2);
}

//create total cart discount
function createCartDiscount(){

  totalCartValue = getTotalVariantPrice(tangent_recommended_products, sections_add_to_cart_map["section_multiple_routine"].list);
  const disocuntedPrice = getDiscountedPrice(totalCartValue, 10);
  const totalCartDiscount = document.getElementById("section_multiple_routine_discount_cart_value");
  

  const totalCartValueNum = parseFloat(totalCartValue) || 0;
  const finalTotal = totalCartValueNum > 0 ? totalCartValueNum.toFixed(2) : totalCartValueNum;

  totalCartDiscount.innerHTML = `<del>${tangent_client_domain_currency} ${finalTotal}</del> <b>${tangent_client_domain_currency} ${disocuntedPrice} </b> with code: TRICHOMATCH10`;
  const div = document.createElement("div");
  div.classList.add('allatcbtn');
  totalCartDiscount.after(div);
  div.innerHTML = `<product-form x-data="productAddButtonForm()" class="product__block__buttons" style="--PB: 20px;">
  <div data-product-form-outer="">
    <form method="post" action="/cart/add" id="addallptocart" accept-charset="UTF-8" class="shopify-product-form" enctype="multipart/form-data" data-product-form="" data-product-handle="scalp-soothe-essential-brush-set">
      <input type="hidden" name="form_type" value="product">
      <input type="hidden" name="utf8" value="✓">
      <div class="product__form__inner" data-form-inner="">
        <div class="product__submit" data-buttons-wrapper="" data-add-action-wrapper="" data-error-boundary="">
          <div data-error-display="" role="alert" class="add-action-errors"></div>
          <div class="product__submit__buttons product__submit__buttons--clear">
          <span class="sr-only" aria-live="polite" x-show="isLoading" style="display: none;">
          Adding to Cart
          </span>
            <span class="sr-only" aria-live="polite" x-show="isSuccess" style="display: none;">
            Added to Cart
            </span>

            <button type="submit" name="add" class="btn--outline btn--full btn--primary btn--add-to-cart" data-add-to-cart="" aria-label="Add to Cart" :class="{
            'has-success': isSuccess,
            'loading': isLoading
            }">
              <span class="btn-state-ready">
                <span data-add-to-cart-text="">Add all to Cart</span>
              </span>

              <span class="btn-state-loading">
                <svg height="18" width="18" class="svg-loader">
                <circle r="7" cx="9" cy="9"></circle>
                <circle stroke-dasharray="87.96459430051421 87.96459430051421" r="7" cx="9" cy="9"></circle>
                </svg>
              </span>
              <span class="btn-state-complete">&nbsp;</span>
            </button>
          </div>
        </div>
      </div>
    <div class="shop-pay-terms"></div>
    </form>
  </div>
</product-form>`;
const uniqueArray = [...new Set(all_p_car_ids)]; 
for (let index = 0; index < uniqueArray.length; index++) {
  const element = uniqueArray[index];
  var input = document.createElement("input");
  input.setAttribute('type', 'hidden');
  input.setAttribute('name', 'id[]');
  input.setAttribute('value', element);
  document.getElementById('addallptocart').append(input);
}
}



// Add to cart button for sections
function createSectionAddAllToCart(section_name) {
    const buttonContainer = document.createElement("div");
    if(section_name == "section_multiple_routine"){
      const discountTag = document.createElement("p");
      discountTag.id = `${section_name}_discount_cart_value`;
      buttonContainer.appendChild(discountTag);
    }
    buttonContainer.classList.add(`${section_name}_button_container`);
    var add_all_to_cart_button = document.createElement("button");
    add_all_to_cart_button.id = section_name;
    add_all_to_cart_button.classList.add("section_add_all_to_cart");
    add_all_to_cart_button.classList.add(section_name+"_add_all_to_cart");

    add_all_to_cart_button.classList.add("section_add_all_cart_link");
    add_all_to_cart_button.classList.add(section_name+"_add_all_cart_link");
    add_all_to_cart_button.setAttribute('data-sectionName', section_name);
    add_all_to_cart_button.innerHTML = default_add_all_to_cart_text;
    buttonContainer.appendChild(add_all_to_cart_button);
    
    // Enabling listener
    add_all_to_cart_button.addEventListener(
        'click',
        function () { addAllTocartFunction(this); },
        false
    );
    return buttonContainer;
    
}

// Container having individual products
function addSectionProductGridContainer(section_name) {
    var product_grid_view_container = document.createElement("div");
    product_grid_view_container.id = section_name+"_product_grid";
    product_grid_view_container.classList.add("section_product_grid");
    product_grid_view_container.classList.add(section_name+"_product_grid");
    return product_grid_view_container;
}

// Tab buttons 
function createTabButton(tab_title) {
    var tab_button = document.createElement("button");
    tab_button.id = tab_title+"_tab_button";
    tab_button.innerHTML = getTabTitle(tabs_title_mapping[tab_title]);
    tab_button.name = tab_title;
    tab_button.classList.add("tablinks");
    tab_button.addEventListener(
        'click',
        function () { switchTab(this); },
        false
    );
    tangent_custom_tabs.appendChild(tab_button);
}

function getTabTitle(section){
  var tab_title;
  if(tabs_title_mapping[section]!=undefined){
    tab_title = tabs_title_mapping[section];
  }
  else{
    tab_title = section.replace("section_","").replace("_"," ").toUpperCase();
  }
  return tab_title;
}
//
// Product Section Creation
function createProductSection(product_sections = {}, text_sections = {}) {
  if (!product_sections || Object.keys(product_sections).length === 0) return;

  for (const section_name in product_sections) {
    const section_container = createSectionContainer(section_name);
    
    // Create text section if exists
    if (text_sections?.[section_name]) {
      createTextSectionBeforeProducts(text_sections, section_container, section_name);
    }

    // Product grid
    section_container.appendChild(addSectionProductGridContainer(section_name));

    // Add all to cart button for routine sections
    if (section_name === "section_multiple_routine" || section_name === "section_single_set_routine") {
      section_container.appendChild(createSectionAddAllToCart(section_name));
    }

    // Append section to correct parent
    if (/section_phase_[1-3]/.test(section_name)) {
      tangent_section_routine_1.appendChild(section_container);
    } else if (section_name === "section_single_set_phase") {
      tangent_section_routine_2.appendChild(section_container);
    } else {
      tangent_sections_wrapper_element.appendChild(section_container);
    }
    
  }
}


// Text Sections with products sections
function createTextSectionBeforeProducts(text_sections,section_container, section_name){
    if(text_sections[section_name]!=undefined){
        var section_div = document.createElement("div");
        section_div.id = section_name+"_text_container";
        section_div.classList.add("section_text_container");
        section_div.classList.add(section_name+"_text_container");
        section_div.innerHTML = text_sections[section_name].join(' ');
        section_container.appendChild(section_div);
    }
}

// Section Text Creation (one without a product section)
function createTextSection(product_sections, text_sections){
    for (const section_name in text_sections) {
        // For removing duplicate entry
        if(product_sections[section_name]!=undefined || section_name == "section_selfie"){
            var section_container = createSectionContainer(section_name);

            var section_div = document.createElement("div");
            section_div.id = section_name+"_text_container";
            section_div.classList.add("section_text_container");
            section_div.classList.add(section_name+"_text_container");
            section_div.innerHTML = text_sections[section_name].join(' ');
            section_container.appendChild(section_div);  

            // To Add to top of the page container
            if(section_name == "section_selfie"){
              var section_selfie = document.querySelector("#section_selfie_container_parent");
              section_selfie.appendChild(section_container);
            }
            else{
              // Add to main container wrapper
              // tangent_sections_wrapper_element.appendChild(section_container); 
            }   
        }
    }
}

// Setting Selfie / Default Image
function setTangentSelfieSection(response) {
  hideLoading();

  const selfieContainer = document.getElementById("tangent_selfie_image_container");
  const selfieImage = document.querySelector("#tangent_selfie_image");
  const containerWrapper = document.querySelector("#tangent_selfie_container");

  if (response?.selfie_html) {
    selfieContainer.innerHTML = response.selfie_html;
    return;
  }

  if (response?.selfie_url) {
    selfieImage.src = response.selfie_url;
    selfieImage.classList.remove("default-selfie-image");
    return;
  }

  if (typeof tangent_default_selfie_image_url === "string" && tangent_default_selfie_image_url.trim() !== "") {
    selfieImage.src = tangent_default_selfie_image_url;
    selfieImage.classList.add("default-selfie-image");
  } else {
    containerWrapper.style.display = "none";
  }
}


// Handle Tab button selection
function switchTab(tab) {
  let i, tabcontent, tablinks;

  // This is to clear the previous clicked content.
  tabcontent = document.querySelectorAll(".tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  
  tablinks = document.querySelectorAll(".tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }

  // Display the clicked tab and set it to active.
  document.getElementById("section_"+tab.name+"_container").style.display = "flex";
  document.getElementById(tab.name+"_tab_button").classList.add("active");

  const addAllToCartButton = document.getElementById("section_multiple_routine");
  const totalCartDiscount = document.getElementById("section_multiple_routine_discount_cart_value");
  const addAllProdsToCartButton = document.getElementById('addallptocart');
  addAllToCartButton.style.display = tab.name === "routine_2" ? "none" : "flex";
  totalCartDiscount.style.display = tab.name === "routine_2" ? "none" : "block";
  addAllProdsToCartButton.style.display = tab.name === "routine_2" ? "none" : "block";
}

// Enabling button listeners
function enableButtonListener(){
    // Listner for section add all to carts
    var add_all_cart_buttons = document.querySelectorAll('.tangent-product-add-btn-wrapper');
    for (var b = 0; b < add_all_cart_buttons.length; b++) {
        add_all_cart_buttons[b].addEventListener(
            'click',
            function () { addToCart(this); },
            false
        );
    }
}

function loadElementsOnResponseData(){
  var all_elements = document.querySelectorAll('.load-on-data');
  for (var ae = 0; ae < all_elements.length; ae++) {
      all_elements[ae].style.display="flex";
  }
}

const showMessage = (message) => {
  const _snackbar = document.getElementById("tangent-message-snackbar");
  _snackbar.innerHTML = message;
  _snackbar.className = "show";

  // After 3 seconds, remove the show class from DIV
  setTimeout(function(){ _snackbar.className = _snackbar.className.replace("show", ""); }, 3000);
}

// Hide loading
function hideLoading(){
  document.querySelector("#loading-section").style.display = "none";
}

function setElementDisplay(elementId, display){
  document.querySelector("#"+elementId).style.display = display;
}